import { State } from '../../../store/state';

export const usersSelector = (state: State) => state.user.users;
export const userSelector = (state: State) => state.user.user;
export const optionsSelector = (state: State) => state.user.options;
export const companiesSelector = (state: State) => state.user.companies;
export const errorCodeSelector = (state: State) => state.user.errorCode;
